import React, {useRef, useState} from 'react';

import Edit from "@/views/Admin/Events/Event/Notifications/Notification/Edit/Edit";
import ChevronDownIcon from '../../../../../../assets/images/icons/16/chevron-d.svg';
import ChevronRightIcon from '../../../../../../assets/images/icons/16/chevron-r.svg';
import ChartIcon from "@/assets/images/icons/16/chart2.svg";
import styles from "@/views/Admin/Events/Event/Notifications/NotificationList/NotificationList.module.scss";
import TicketIcon from "@/assets/images/icons/16/ticket.svg";
import Toggletip from "@/UIKit/component/toggletip/toggletip";
import EditIcon from "@/assets/images/icons/16/pencil.svg";
import ClockIcon from "@/assets/images/icons/16/clock.svg";
import Select from "@/UIKit/component/select/Select";
import DotsIcon from "@/assets/images/icons/16/more-vertical.svg";
import Switcher from "@/UIKit/component/switcher/Switcher";
import Confirm from "@/UIKit/component/confirm/confirm";
import {TagsChannel} from "@/views/Admin/Events/Event/Notifications/components/TagChannels";

import {useSelector} from "react-redux";

const NotificationList = (props) => {
    const ref = useRef(document.querySelector('.settings-container'))
    const is_send_users = useSelector(state => state.admin.event.is_send_users)

    const handleShow = () => {
        props.setShowVersion(prev => !prev)
    }

    const ticketsLabel = (v) => {

        let tickets = props.ticketsFilter({tickets: props.tickets, type: v.attributes.ticket_types})
        if (!tickets || !v.ticket_ids) return ''
        if (v.attributes.original_id === null && !v.ticket_ids.length) return 'Все' //для оригинала

        return tickets
            .filter((ticket) => v.ticket_ids.includes(ticket.id))
            .map((ticket) => ticket.label)
            .join(", ");
    }

    return (
        <div className={styles.notificationList}>
            <div className={styles.containerHead}>
                <div className={styles.nameHead}>
                    <button
                        onClick={handleShow}>
                        {props.showVersion ? <ChevronDownIcon/> : <ChevronRightIcon/>}
                    </button>
                    {props.data.attributes.name}
                </div>
                <div className={styles.type}>
                    <span>тип билета:</span>
                    {props.data.info.ticket_types}
                </div>
                <div className={styles.statistic}></div>
                <div className={styles.actions}></div>
                <div className={styles.switchers}></div>
            </div>
            {props.showVersion && props.versions.map((version, idx) => {
                return version.attributes.is_edit ?
                    <Edit
                        key={idx}
                        data={version}
                        tickets={props.ticketsFilter({tickets: props.tickets, type: version.attributes.ticket_types})}
                        variables={props.variables}
                        onSaveNotification={props.handleSaveNotification}
                        onSaveTemplate={props.handleSaveTemplate}
                        onRemoveTemplate={props.handleRemoveTemplate}
                        onGetTemplates={props.handleGetUserTemplates}
                        onCancel={props.handleCancelForm}
                        onTest={props.handleTestMessage}
                        channelsList={props.channelsList}
                    /> :
                    <div key={idx} className={`${styles.container} ${styles.containerVersion}`}>
                        {version.attributes.is_confirm === 'reset' ? <Confirm
                            type={'danger'}
                            message={`Удалить шаблон ?`}
                            onCancelText={'Отмена'}
                            onSubmitText={'Удалить'}
                            direction={'row'}
                            onCancel={(val) => props.handleConfirm(val, version)}
                            onSubmit={() => props.handleReset(version)}
                        /> : null}

                        {version.attributes.is_confirm === 'remove' ? <Confirm
                            type={'danger'}
                            message={`Удалить уведомление?`}
                            onCancelText={'Отмена'}
                            onSubmitText={'Удалить'}
                            direction={'row'}
                            onCancel={(val) => props.handleConfirm(val, version)}
                            onSubmit={() => props.handleReset(version)}
                        /> : null}
                        <div className={styles.channels}>
                            <TagsChannel channelsList={props.channelsList} mask={version.attributes.channels}/>
                        </div>
                        <div className={styles.type}>
                            <TicketIcon/>
                            {ticketsLabel(version)}
                        </div>
                        <div className={styles.statistic}>
                            <p>{version.info.planned_at}</p>
                        </div>
                        <div className={styles.actions}>
                            {version.actions.notify && <button
                                className={`a-btn a-btn_size_small a-btn_quare a-btn_type_secondary-ghost ${styles.buttonN}`}
                                title={'Настроить время отправки'}
                                disabled={props.data.attributes.is_disabled}
                                onClick={() => props.handleCallWindow({type: 'periodVersion', version: version})}>
                                <ClockIcon/>
                            </button>}
                            <div style={{height: "max-content"}}>
                                <Toggletip content={props.parseToggle(props.statistics)}>
                                    <button
                                        className={`a-btn a-btn_size_small a-btn_quare a-btn_type_secondary-ghost ${styles.buttonN}`}
                                        title={'Статистика'}
                                        disabled={version.attributes.is_disabled}
                                        onClick={() => props.handleStatistics(version)}>
                                        <ChartIcon/>
                                    </button>
                                </Toggletip>
                            </div>
                            <button
                                className={`a-btn a-btn_size_small a-btn_quare a-btn_type_secondary-ghost ${styles.buttonN}`}
                                title={'Редактировать'}
                                disabled={version.attributes.is_disabled || !version.actions.edit}
                                onClick={() => props.handleEdit({version: version})}>
                                <EditIcon/>
                            </button>
                            <Select
                                data={props.generateAvailableActions({type: 'versions'})}
                                parentRef={ref}
                                onChange={(key) => props.handleSelectAction(key, version)}
                                disabled={version.attributes.is_disabled || !version.actions.disable || !Object.keys(props.generateAvailableActions({type: 'versions'})).length}
                            >
                                <div
                                    className={`a-btn a-btn_size_small a-btn_quare a-btn_type_secondary-ghost ${styles.buttonN}`}>
                                    <DotsIcon/>
                                </div>
                            </Select>

                        </div>
                        <div className={styles.switchers}>
                            <Switcher
                                id={`notification-switcher__${version.hash}`}
                                size={'small'}
                                parent={document.querySelector('main')}
                                value={null}
                                checked={!is_send_users ? false : version.attributes.is_active}
                                disabled={!is_send_users ? true : version.attributes.is_disabled || !version.actions.disable}
                                onChange={() => props.handleActive({
                                    id: version.id,
                                    hash: version.hash,
                                    value: version.attributes.is_active,
                                    ticket_ids: version.ticket_ids
                                })}
                                error={null}
                            />
                        </div>
                    </div>

            })
            }
        </div>
    );
};

export default NotificationList;
